(function () {
    'use strict';
    $('body').on('keypress', '.decimalsOnly', function (e) {
        // Allow: backspace, tab, escape, enter and delete

        if (($.inArray(e.charCode, [8, 9, 27, 13, 45, 46]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) && $(this)[0].value.indexOf('.') === -1 && $(this)[0].value.indexOf('-') === -1) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (e.shiftKey || (e.charCode < 48 || e.charCode > 57)) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.numbersOnly', function (e) {
        // Allow: backspace, tab, escape, enter and delete

        if ($.inArray(e.charCode, [8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (e.shiftKey || (e.charCode < 48 || e.charCode > 57) && $.inArray(e.keyCode, [8, 9, 46, 35, 36, 37, 38, 39, 40]) === -1) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.onlynumbersandhyphen', function (e) {
        // Allow: backspace, tab, escape, enter and delete

        if ($.inArray(e.charCode, [8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress

        if (e.charCode != 45 && (e.shiftKey || (e.charCode < 48 || e.charCode > 57) && $.inArray(e.keyCode, [8, 9, 46, 35, 36, 37, 38, 39, 40]) === -1)) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.allowNumbersOnly', function (e) {
        // Allow: backspace, tab, escape, enter and delete

        if ($.inArray(e.charCode, [8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (e.shiftKey || (e.charCode < 48 || e.charCode > 57) && $.inArray(e.keyCode, [8, 9, 46, 35, 36, 37, 38, 39, 40]) === -1) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.numberRangeUpto20', function (e) {
        // Allow: backspace, tab, escape, enter and delete

        var textComponent = $(this);
        var startPos = textComponent[0].selectionStart;
        var endPos = textComponent[0].selectionEnd;
        var selectedText = textComponent[0].value.substring(startPos, endPos)

        var _val = e.currentTarget.value.replace(selectedText, '') + e.key;

        if (_val != "" && !isNaN(parseInt(_val)) && parseInt(_val) > 20 || parseInt(_val) === 0) {
            e.preventDefault();
        }

        if ($.inArray(e.charCode, [8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            return;
        }
        // Ensure that it is a number and stop the keypress
        if (e.shiftKey || (e.charCode < 48 || e.charCode > 57) && $.inArray(e.keyCode, [8, 9, 35, 36, 37, 38, 39, 40]) === -1) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.alphabetsOnly', function (e) {
        // Allow: backspace, tab, escape, enter and delete
        if ($.inArray(e.charCode, [8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.charCode < 65 || e.charCode > 90) && (e.charCode < 97 || e.charCode > 122)) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.alphabetsWithSpaceOnly', function (e) {
        // Allow: backspace, tab, escape, enter and delete
        if ($.inArray(e.charCode, [8, 9, 27, 13, 32]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.charCode < 65 || e.charCode > 90) && (e.charCode < 97 || e.charCode > 122) && $.inArray(e.keyCode, [8, 9, 46, 35, 36, 37, 38, 39, 40]) === -1) {
            e.preventDefault();
        }
    });

    $('body').on('change', '.alphabetsWithSpaceHyphen, .alphabetsWithOnlyOneSpace, .alphabetsWithOnlyOneSpaceHyphen', function (e) {
        var value = $(this).val().trim();
        $(this).val(value);
    })

    $('body').on('keypress', '.alphabetsWithOnlyOneSpace', function (e) {
        // Allow: backspace, tab, escape, enter and delete
        //var re = /^(([a-zA-Z])+[\s-])?[a-zA-Z]+$/;


        if (($.inArray(e.charCode, [8, 9, 27, 13, 32]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) && $(this)[0].value.indexOf(' ') === -1) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything

            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.charCode < 65 || e.charCode > 90) && (e.charCode < 97 || e.charCode > 122) && $.inArray(e.keyCode, [8, 9, 46, 35, 36, 37, 38, 39, 40]) === -1) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.alphabetsWithOnlyOneSpaceHyphen', function (e) {
        // Allow: backspace, tab, escape, enter and delete
        //var re = /^(([a-zA-Z])+[\s-])?[a-zA-Z]+$/;


        if ((($.inArray(e.charCode, [8, 9, 27, 13, 32]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) && $(this)[0].value.indexOf(' ') === -1) || (($.inArray(e.charCode, [8, 9, 27, 13, 45]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) && $(this)[0].value.indexOf('-') === -1)) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything

            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.charCode < 65 || e.charCode > 90) && (e.charCode < 97 || e.charCode > 122) && $.inArray(e.keyCode, [8, 9, 46, 35, 36, 37, 38, 39, 40]) === -1) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.alphabetsWithOnlyOneSpaceHyphenAfterSecondChar', function (e) {
        // Allow: backspace, tab, escape, enter and delete
        //var re = /^(([a-zA-Z])+[\s-])?[a-zA-Z]+$/;


        if ((($.inArray(e.charCode, [8, 9, 27, 13, 32]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) && $(this)[0].value.indexOf(' ') === -1) || (($.inArray(e.charCode, [8, 9, 27, 13, 45]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) && $(this)[0].value.indexOf('-') === -1)) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            if (e.target.value.length > 1 && ($.inArray(e.charCode, [32, 45]) !== -1)) {
                return;
            }
        }
        // Ensure that it is a number and stop the keypress
        if ((e.charCode < 65 || e.charCode > 90) && (e.charCode < 97 || e.charCode > 122) && $.inArray(e.keyCode, [8, 9, 46, 35, 36, 37, 38, 39, 40]) === -1 && !(e.target.value.length > 1 && ((e.charCode == 45 && e.target.value.indexOf('-') === -1) || (e.target.value.indexOf(' ') === -1 && e.target.value.indexOf(' ') === -1)))) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.alphabetsWithSpaceHyphen', function (e) {
        // Allow: backspace, tab, escape, enter and delete
        //var re = /^(([a-zA-Z])+[\s-])?[a-zA-Z]+$/;


        if ($.inArray(e.charCode, [8, 9, 27, 13, 32, 45]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything

            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.charCode < 65 || e.charCode > 90) && (e.charCode < 97 || e.charCode > 122)) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.alphaNumericOnly', function (e) {
        // Allow: backspace, tab, escape, enter and delete

        if ($.inArray(e.charCode, [8, 9, 27, 13]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.charCode < 65 || e.charCode > 90) && (e.charCode < 97 || e.charCode > 122) && (e.charCode < 48 || e.charCode > 57)) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.alphaNumericWithSpaceOnly', function (e) {
        // Allow: backspace, tab, escape, enter and delete

        if ($.inArray(e.charCode, [8, 9, 27, 13, 32]) !== -1 ||
            // Allow: Ctrl+A, Command+A
            (e.charCode === 65 && (e.ctrlKey === true || e.metaKey === true))) { //||
            // Allow: home, end, left, right, down, up
            //(e.charCode >= 35 && e.charCode <= 40)) {
            // let it happen, don't do anything
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.charCode < 65 || e.charCode > 90) && (e.charCode < 97 || e.charCode > 122) && (e.charCode < 48 || e.charCode > 57)) {
            e.preventDefault();
        }
    });

    $('body').on('keypress', '.disableEnter', function (e) {
        if (e.keyCode == 13) {
            e.preventDefault();
        }
    });

    $('body').on('click', '.fa-close', function () {
        var alert = $(this).parent('.alert-dismissable');
        var scope = getScope(alert);
        hideMessage(scope);
        scope.$apply();
    });

    var hideMessage = function (scope) {
        if (scope !== undefined) {
            scope.$parent.isError = false;
            scope.$parent.isSuccess = false;
            scope.$parent.isSubscriptionSuccess = false;
            scope.$parent.isSubscriptionError = false;
            scope.$parent.isModalError = false;
            scope.$parent.isModalSuccess = false;
        }
    }

    $("body").on('click', '.show-hide-password', function () {
        $(".show-hide-password .fa").toggleClass("fa-eye fa-eye-slash");
        if ($(".show-hide-password .fa").hasClass("fa-eye")) {
            $("#tabpassword, #registerPassword, #newPassword, #resetPassword").attr('type', 'password');
        }
        else {
            $("#tabpassword, #registerPassword, #newPassword, #resetPassword").attr('type', 'text');
        }
    });

    $("body").on('keyup', '#tabpassword, #registerPassword, #newPassword, #resetPassword', function () {
        if ($(this).val().length > 0) {
            $(this).parent().find(".show-hide-password").show();
        }
        else {
            $(this).parent().find(".show-hide-password").hide();
        }
    });

    $('body').on('focus', '.signup-tooltip, #registerPassword, #newPassword, #resetPassword', function () {
        if (window.innerWidth >= 768) {
            var _this = $(this);
            var _top = $(_this).offset().top;
            var _left = $(_this).offset().left;
            var txtLength = $(_this).width();

            $(this).siblings("#customPopover").css({ position: 'absolute', display: 'block' });
            $(this).siblings('#customPopover').removeClass('hide');
        }
    }).on('focusout', '.signup-tooltip, #registerPassword, #newPassword, #resetPassword', function () {
        $(this).siblings("#customPopover").css({ display: 'none' });
        $(this).siblings('#customPopover').addClass('hide');
    });

    $('body').on('click', '.password-info', function () {
        if (window.innerWidth < 768) {
            var element = document.getElementById("firstNameInfo").nextSibling;
            if (element != null) {
                element.className += " profileFirstNamePopover";
                var arrowElement = element.firstChild;
                if (arrowElement != null) {
                    arrowElement.className += " profileFirstNamePopoverArrow";
                }
            }
            element = document.getElementById("lastNameInfo").nextSibling;
            if (element != null) {
                element.className += " profileLastNamePopover";
                arrowElement = element.firstChild;
                if (arrowElement != null) {
                    arrowElement.className += " profileLastNamePopoverArrow";
                }
            }
        }
    });

    $('body').on('focus', '.hidden-default-upload-btn', function () {
        $('.upload-file-browse-btn').addClass('upload-file-browse-btn-focus');
    }).on('focusout', '.hidden-default-upload-btn', function () {
        $('.upload-file-browse-btn').removeClass('upload-file-browse-btn-focus');
    });

    $('body').on('focus', '.first-as-rd-btn, .second-as-rd-btn, .third-as-rd-btn', function () {
        var _this = $(this);
        if (_this.hasClass('first-as-rd-btn')) {
            $('.first-as-sp-btn').addClass('upload-file-radio-btn-focus');
        } else if (_this.hasClass('second-as-rd-btn')) {
            $('.second-as-sp-btn').addClass('upload-file-radio-btn-focus');
        } else {
            $('.third-as-sp-btn').addClass('upload-file-radio-btn-focus');
        }
    }).on('focusout', '.first-as-rd-btn, .second-as-rd-btn, .third-as-rd-btn', function () {
        var _this = $(this);
        if (_this.hasClass('first-as-rd-btn')) {
            $('.first-as-sp-btn').removeClass('upload-file-radio-btn-focus');
        } else if (_this.hasClass('second-as-rd-btn')) {
            $('.second-as-sp-btn').removeClass('upload-file-radio-btn-focus');
        } else {
            $('.third-as-sp-btn').removeClass('upload-file-radio-btn-focus');
        }
    });

    $('body').on('click', '.workspace-dropdown', function () {
        $('#techCheckboxes').hide();
        $('#spectralCheckboxes').hide();
    })

    $('body').on('focus', '.workspace-select', function () {
        $('.workspace-dropdown').addClass('workspace-dropdown-focus');
    }).on('focusout', '.workspace-select', function () {
        $('.workspace-dropdown').removeClass('workspace-dropdown-focus');
    });

    $('body').on('focusout', '#professionaltitle, #firstName, #lastName, #city, #otherState, #PrimaryIndustry, #LatestProject', function () {
        if ($(location).attr('href').indexOf('profile') > -1) {
            var _this = this;
            _this.setSelectionRange(0, 0);
        }
    });

    $(document).on('show.bs.modal', '.modal', function () {
        $('body').css('overflow', 'hidden');
    }).on('hidden.bs.modal', '.modal', function () {
        $('body').css('overflow', 'auto');
    });;

    $(document).click(function (e) {
        if (e.target.className.indexOf('search-dropdown-label') == -1 && e.target.className.indexOf('search-dropdown-ip') == -1 && e.target.className.indexOf('search-tech-select') == -1 && e.target.className.indexOf('search-spectral-select') == -1) {
            $('#techCheckboxes').hide();
            $('#spectralCheckboxes').hide();
        }
        var target = e.target;
        var parentNode = target.parentNode

        if (target != null) {
            if (target.className.indexOf('techCheckboxes') != -1 || (parentNode != null && parentNode.parentNode != null && parentNode.parentNode.className.indexOf('techCheckboxes')) != -1 || (parentNode != null && parentNode.className.indexOf('techCheckboxes') != -1)) {
                $('#techCheckboxes').show();
            } else if (target.className.indexOf('search-tech-select') != -1) {
                $('#techCheckboxes').toggle();
            } else {
                $('#techCheckboxes').hide();
            }

            if (target.className.indexOf('spectralCheckboxes') != -1 || (parentNode != null && parentNode.parentNode != null && parentNode.parentNode.className.indexOf('spectralCheckboxes') != -1) || (parentNode != null && parentNode.className.indexOf('spectralCheckboxes') != -1)) {
                $('#spectralCheckboxes').show();
            } else if (target.className.indexOf('search-spectral-select') != -1) {
                $('#spectralCheckboxes').toggle();
            } else {
                $('#spectralCheckboxes').hide();
            }
        }
    });

    app.service('CommonService', ['$http', '$q', '$rootScope', '$cookies',
    function ($http, $q, $rootScope, $cookies) {
        var serviceBase = $rootScope.buildConfig.aippsssApiBaseUrl;
        var deferred;

        this.getUserByEmail = function (userName) {
            deferred = $q.defer();
            $http.get(serviceBase + "api/Account/user?username=" + userName
                ).then(function (response) {
                    deferred.resolve(response);
                })
            .catch(function (err) {
                deferred.resolve(err);
            });

            return deferred.promise;
        }

        this.validatePassword = function (scope, event) {
            var _value = $(event.currentTarget).val();
            var regUppercase = /(?=.*[A-Z])/ //uppercase letters
            var regNumbers = /(?=.*\d)/ //Numbers
            var regSpecial = /(?=.*[!@#$%^&*()_+=-])/ //Special Characters

            if (_value.length > 6) {
                scope.PasswordLength = true;
            } else {
                scope.PasswordLength = false;
            }
            var isValid = regUppercase.test(_value);
            if (isValid) {
                scope.UpperCase = true;
            } else {
                scope.UpperCase = false;
            }

            isValid = regNumbers.test(_value);
            if (isValid) {
                scope.Numbers = true;
            } else {
                scope.Numbers = false;
            }

            isValid = regSpecial.test(_value);
            if (isValid) {
                scope.SpecialCharacters = true;
            } else {
                scope.SpecialCharacters = false;
            }
        }
    }]);

})();

function msieversion() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf("MSIE ");
    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer, return true
    {
        return true;
    } else { // If another browser,
        return false;
    }
}

function get_browser_info() {
    var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return { name: 'IE ', version: (tem[1] || '') };
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR\/(\d+)/)
        if (tem !== null) { return { name: 'Opera', version: tem[1] }; }
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) !== null) { M.splice(1, 1, tem[1]); }
    return {
        name: M[0],
        version: M[1]
    };
}

function downloadCSV(args, csv) {
    var data, filename, link;

    if (csv === null) return;

    filename = args || 'export.csv';
    if (msieversion()) {
        var IEwindow = window.open();
        IEwindow.document.write('sep=,\r\n' + csv);
        IEwindow.document.close();
        IEwindow.document.execCommand('SaveAs', true, filename);
        IEwindow.close();
    } else {
        var browser = get_browser_info();
        //if (!csv.match(/^data:text\/csv/i)) {
        csv = 'data:attachment/csv;charset=utf-8,' + csv;
        //}
        data = encodeURI(csv);

        link = document.createElement('a');
        link.setAttribute('href', data);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        if (browser.name.toLowerCase() === 'safari') {
            var cle = document.createEvent("MouseEvent");
            cle.initEvent("click", true, true);
            link.dispatchEvent(cle);
        } else {
            link.click();
        }
        document.body.removeChild(link);
    }
}

function BlobDownloadCSV(fileName, csv) {
    var blob;
    try {
        blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    } catch (e) {
        if (e.name == "InvalidStateError") {
            // InvalidStateError (tested on Win7 & Win8 IE11)
            var bb = new MSBlobBuilder();
            bb.append(csv);
            blob = bb.getBlob('text/csv;charset=utf-8');
        } else {
            // We're screwed, blob constructor unsupported entirely
        }
    }
    if (navigator.msSaveBlob) { // IE 10+
        navigator.msSaveBlob(blob, fileName);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

function getScope(element) {
    return angular.element(element).scope();
}

function encrypt(value) {
    var b64 = unescape(encodeURIComponent(value))
    return window.btoa(b64);
}

function decrypt(value) {

    return decodeURIComponent(escape(window.atob(value)));
}

function setLocalValue(key, value) {
    var info;
    info = localStorage.getItem('appInfo');
    if (info != undefined && info != null && info != '') {
        info = JSON.parse(decrypt(info));
        info[key] = value;

        info = encrypt(JSON.stringify(info));
        localStorage.removeItem('appInfo');
        localStorage.setItem('appInfo', info);
    } else {
        info = {};
        info[key] = value;

        info = encrypt(JSON.stringify(info));
        localStorage.removeItem('appInfo');
        localStorage.setItem('appInfo', info);
    }
}

function getLocalValue(key) {
    var info;
    info = localStorage.getItem('appInfo');
    if (info != undefined && info != null && info != '') {
        info = JSON.parse(decrypt(info));

        return info[key];
    }
}

function setCookie(key, value, $cookies) {
    var cookieArr;
    cookieArr = $cookies.get('appCookie');
    if (cookieArr != undefined && cookieArr != null && cookieArr != '') {
        cookieArr = JSON.parse(decrypt(cookieArr));
        cookieArr[key] = value;
        cookieArr = encrypt(JSON.stringify(cookieArr));
        $cookies.remove('appCookie');
        $cookies.put('appCookie', cookieArr);
    } else {
        cookieArr = {};
        cookieArr[key] = value;
        cookieArr = encrypt(JSON.stringify(cookieArr));
        $cookies.put('appCookie', cookieArr);
    }
}

function getCookie(key, $cookies) {
    var cookieArr;
    cookieArr = $cookies.get('appCookie');
    if (cookieArr != undefined && cookieArr != null && cookieArr != '') {
        cookieArr = JSON.parse(decrypt(cookieArr));
        return cookieArr[key];
    }
}